import { REGIONS_ARRAY } from '@/data'
import metadata from './metadata'
import menuItemData from './menuItemData'
import blogPost from './blogPost'
import locationData from './locationData'
import pageData from './pageData'

/* eslint-disable */
export const pageMetadataFields = `
  _type,
  _createdAt,
  _updatedAt,
  title,
  slug,
  enabledRegions,
  metadata {
    // Default fallback to en-us - will be overridden by specific language conditions below
    ...(en_usMetadata) {
      ${metadata.fields}
    },
    ${REGIONS_ARRAY
      .map(regionCode => {
        return `
        $language == "${regionCode}" => {
          ...(${regionCode}Metadata) {
            ${metadata.fields}
          }
        }
      `
      })
      .join(',')}
  },
  ${REGIONS_ARRAY
    .map(regionCode => {
      return `
      $language == "${regionCode}" => {
        "isEnabled": $language in enabledRegions
      }
    `
    })
    .join(',')},
  _type == "page" => {
    ${pageData.fields}
  },
  _type == "menuItem" => {
    ${menuItemData.fields}
  },
  _type == "location" => {
    ${locationData.fields}
  },
  _type == "blogPost" => {
    ${blogPost.fields}
  },
  "globalMetaData": {
    ...(*[_type == "siteSettingsMetadata"] {
      _type,
      ${REGIONS_ARRAY
        .map(regionCode => {
          return `
          $language == "${regionCode}" => {
            ...(${regionCode}SiteSettingsMetadata) {
              ${metadata.fields}
            }
          }
        `
        })
        .join(',')}
    }[0])
  }
`

export const pageSitemapFields = `
  _type,
  _updatedAt,
  slug,
  metadata {
    ${REGIONS_ARRAY
      .map(regionCode => {
        return `
        $language == "${regionCode}" => {
          ...(${regionCode}Metadata) {
            noindex
          }
        }
      `
      })
      .join(',')}
  },
  ${REGIONS_ARRAY
    .map(regionCode => {
      return `
      $language == "${regionCode}" => {
        "isEnabled": $language in enabledRegions
      }
    `
    })
    .join(',')},
`

/* eslint-enable */
